export default{sources:{avif:"__VITE_ASSET__BN9ybiWY__ 400w",webp:"__VITE_ASSET__CYPvs1S8__ 400w"},img:{src:"__VITE_ASSET__CiAB3klc__",w:400,h:600}};